import user from '@/user'
import userProvider from '@/providers/user/user'
const state = {
	sync: false,
	users: []
}

const mutations = {
	SET_USERS: (state, users) => {
		state.users = users
		state.sync = true
	}
}

const actions = {
	sync: (context) => {
		let params = {
			all: 1,
			expand: 'photo'
		}
		userProvider.getAll(params).then((users) => {
			context.commit('SET_USERS', users)
		})
	},
	socket_socketUserUpdated: (context, message) => {
		context.dispatch('sync')
		user.update()
	}
}

const getters = {
	users: state => {
		return state.users
	}
}

export default {
	actions,
	getters,
	mutations,
	namespaced: true,
	state
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js